module.exports = __webpack_public_path__ + "img/0.03850e73.png";